export default {
  GETTERS: {
    GET_IS_VISIBLE: 'FLASH/GET_IS_VISIBLE',
    GET_TITLE: 'FLASH/GET_TITLE',
    GET_SUBTITLE: 'FLASH/GET_SUBTITLE',
    GET_TYPE: 'FLASH/GET_TYPE',
    GET_LINK: 'FLASH/GET_LINK',
    GET_SHOW_CLOSE_BUTTON: 'FLASH/GET_SHOW_CLOSE_BUTTON',
    GET_HEX_COLORS: 'FLASH/GET_HEX_COLORS',
    GET_ICON: 'FLASH/GET_ICON',
    GET_OPTIONS: 'FLASH/GET_OPTIONS',
    GET_SHOULD_AUTO_CLOSE: 'FLASH/SHOULD_AUTO_CLOSE',
    GET_IS_FIXED: 'FLASH/IS_FIXED',
    GET_IMAGE_URL: 'FLASH/GET_IMAGE_URL',
    GET_DURATION: 'FLASH/DURATION',
    GET_CONTENT_ALIGNMENT: 'FLASH/CONTENT_ALIGNMENT'
  },
  MUTATIONS: {
    SET_FLASH: 'FLASH/SET_FLASH',
    SET_IS_VISIBLE: 'FLASH/SET_IS_VISIBLE'
  }
}
